// components/Services.jsx
import React from 'react';

const services = [
  {
    icon: (stroke) => <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>,
    title: 'Haematology',
    desc: 'Complete blood analysis to evaluate your overall health and detect a wide range of disorders including anaemia and clotting disorders.',
    pills: ['CBC', 'ESR', 'Platelet Count', 'Blood Grouping']
  },
  {
    icon: (stroke) => <><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></>,
    title: 'Biochemistry',
    desc: 'Detailed serum analysis for kidney, liver, and metabolic function. Essential for monitoring chronic conditions and general wellness.',
    pills: ['LFT', 'KFT', 'Lipid Profile', 'Blood Sugar']
  },
  {
    icon: (stroke) => <><path d="M12 2a10 10 0 100 20A10 10 0 0012 2z"/><path d="M12 6v6l4 2"/></>,
    title: 'Endocrinology',
    desc: 'Hormonal assessments to diagnose thyroid disorders, diabetes, and other endocrine abnormalities with high accuracy.',
    pills: ['Thyroid Panel', 'HbA1c', 'Insulin', 'Cortisol']
  },
  {
    icon: (stroke) => <><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    title: 'Serology & Immunology',
    desc: 'Detection of infections and immune response testing. Critical for diagnosing viral, bacterial, and autoimmune conditions.',
    pills: ['VDRL', 'Widal', 'RA Factor', 'ANA']
  },
  {
    icon: (stroke) => <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>,
    title: 'Urine & Stool Analysis',
    desc: 'Routine and microscopic examination of urine and stool to assess kidney function, infections, and gastrointestinal health.',
    pills: ['Urine RE/ME', 'Culture', 'Stool RE', 'Occult Blood']
  },
  {
    icon: (stroke) => <><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></>,
    title: 'Health Packages',
    desc: 'Curated preventive health checkup bundles at affordable prices — ideal for annual screenings, pre-employment, and family wellness.',
    pills: ['Basic Wellness', 'Comprehensive', 'Senior Package', "Women's Health"]
  }
];

const Services = () => {
  return (
    <section id="services" className="py-20 px-8 bg-white">
      <div className="max-w-[1200px] mx-auto">
        <p className="text-teal text-[0.75rem] font-semibold tracking-[2px] uppercase mb-3">What We Offer</p>
        <h2 className="text-4xl md:text-5xl text-charcoal font-serif mb-4">Comprehensive Diagnostic<br/>Services</h2>
        <p className="text-[#5a7a77] max-w-md leading-relaxed">From routine blood tests to specialized panels — all under one roof, processed with precision instruments and reviewed by expert pathologists.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {services.map((s, idx) => (
            <div key={idx} className="bg-cream rounded-2xl p-8 border border-[#e5edeb] transition-all hover:bg-white hover:border-[#b2d9d4] hover:shadow-lg hover:-translate-y-1 cursor-default">
              <div className="w-13 h-13 bg-teal-light rounded-xl flex items-center justify-center mb-5">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0f7a6e" strokeWidth="2" strokeLinecap="round">
                  {s.icon()}
                </svg>
              </div>
              <h3 className="text-charcoal text-lg font-serif mb-2">{s.title}</h3>
              <p className="text-[#6b8a87] text-sm leading-relaxed">{s.desc}</p>
              <div className="flex flex-wrap gap-1.5 mt-4">
                {s.pills.map((pill, i) => (
                  <span key={i} className="text-[0.72rem] bg-white text-[#4a7570] px-2.5 py-0.5 rounded-full border border-[#cce3e0] font-medium">{pill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;